import { render, staticRenderFns } from "./stickerWrapper.vue?vue&type=template&id=9e536c2a"
import script from "./stickerWrapper.vue?vue&type=script&lang=js"
export * from "./stickerWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e536c2a')) {
      api.createRecord('9e536c2a', component.options)
    } else {
      api.reload('9e536c2a', component.options)
    }
    module.hot.accept("./stickerWrapper.vue?vue&type=template&id=9e536c2a", function () {
      api.rerender('9e536c2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/storyTab/storyMaker/stiker/stickerWrapper.vue"
export default component.exports